var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26895 33.2223C8.90128 33.2223 8.58876 33.0998 8.33138 32.8548C8.074 32.6034 7.94531 32.305 7.94531 31.9595C7.94531 31.6076 8.074 31.3061 8.33138 31.0547C8.58876 30.8034 8.90128 30.6777 9.26895 30.6777C9.64276 30.6777 9.95835 30.8034 10.2157 31.0547C10.4792 31.3061 10.611 31.6076 10.611 31.9595C10.611 32.305 10.4792 32.6034 10.2157 32.8548C9.95835 33.0998 9.64276 33.2223 9.26895 33.2223Z",
    fill: "#512BD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9666 33.0149H21.5766L15.2802 23.0814C15.1209 22.8301 14.989 22.5693 14.8849 22.2991H14.8297C14.8788 22.5882 14.9033 23.2071 14.9033 24.1557V33.0149H12.7891V19.5H15.3352L21.4204 29.1979C21.6778 29.6001 21.8432 29.8765 21.9168 30.0273H21.9535C21.8923 29.6692 21.8616 29.0629 21.8616 28.2083V19.5H23.9666V33.0149Z",
    fill: "#512BD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2608 33.0149H26.8613V19.5H33.9667V21.4038H29.0491V25.2301H33.5807V27.1245H29.0491V31.1205H34.2608V33.0149Z",
    fill: "#512BD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7781 21.4038H40.991V33.0149H38.8033V21.4038H35.0254V19.5H44.7781V21.4038Z",
    fill: "#512BD4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    stroke: "#512BD4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.c88ea0ee93444d838ef6b5f198d29c3f.svg";
export { ForwardRef as ReactComponent };